import * as React from 'react';
import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import { removeFavoriteListing } from '../actions';
import { Actions as addFavoriteListingActions } from '../actions/addFavoriteListing';

import {
  isLoading as isLoadingSelector,
  isFavorite as isFavoriteSelector,
} from '../selectors';

interface Children {
  onClick: React.MouseEventHandler;
  isLoading: boolean;
  isFavorite: boolean;
}

interface OwnProps {
  listingId: number;
}

interface Props {
  isLoading: boolean;
  isFavorite: boolean;
  addFavorite: (listingId: number) => void;
  removeFavorite: (listingId: number) => void;
  children: (p: Children) => JSX.Element;
}

export class FavoriteListingContainer extends React.Component<
  Props & OwnProps
> {
  handleClick: React.MouseEventHandler<HTMLDivElement> = e => {
    const {
      isLoading,
      isFavorite,
      addFavorite,
      removeFavorite,
      listingId,
    } = this.props;

    e.stopPropagation();
    e.preventDefault();

    if (isLoading) {
      return;
    }

    isFavorite ? removeFavorite(listingId) : addFavorite(listingId);
  };

  render() {
    const { children, isFavorite, isLoading } = this.props;
    return children({
      onClick: this.handleClick,
      isFavorite,
      isLoading,
    });
  }
}

const enhance = connect(
  (stateProps: GlobalState, ownProps: OwnProps) => ({
    isLoading: isLoadingSelector(stateProps, ownProps.listingId),
    isFavorite: isFavoriteSelector(stateProps, ownProps.listingId),
  }),
  {
    addFavorite: addFavoriteListingActions.addToPendingList,
    removeFavorite: removeFavoriteListing,
  },
);

export default enhance(FavoriteListingContainer);
